export const NULL = null;
export const BY_PASS_PERMISSION = "-";

export const RESOURCE_REVOKE_PERMISSION = "RESOURCE.ASSIGNMENT.REVOKE";
export const RESOURCE_ASSIGN_PERMISSION = "RESOURCE.ASSIGNMENT.ASSIGN";
export const RESOURCE_VIEW_PERMISSION = "RESOURCE.ASSIGNMENT.VIEW";

export const GROUP_CREATE_PERMISSION = "TEAM.GROUP.CREATE";
export const GROUP_MOVE_PERMISSION = "TEAM.GROUP.MOVE";
export const GROUP_STATUS_PERMISSION = "TEAM.GROUP.STATUS";
export const GROUP_VIEW_PERMISSION = "TEAM.GROUP.VIEW";
export const SUBGROUP_VIEW_PERMISSION = "TEAM.SUBGROUP.VIEW";
export const GROUP_SETTINGS_PERMISSION = "TEAM.GROUP.SETTINGS";


export const USER_CREATE_PERMISSION = "TEAM.USERS.CREATE";
export const USER_MOVE_PERMISSION = "TEAM.USER.MOVE";
export const USER_STATUS_PERMISSION = "TEAM.USERS.STATUS";
export const USER_VIEW_PERMISSION = "TEAM.USERS.VIEW";

export const ROLES_VIEW_PERMISSION = "TEAM.ROLES.VIEW";
export const ROLES_CREATE_PERMISSION = "TEAM.ROLES.CREATE";
export const ROLES_DEFAULT_PERMISSION = "TEAM.ROLES.DEFAULT";
export const ROLES_DELETE_PERMISSION = "TEAM.ROLES.DELETE";
export const ROLES_EDIT_PERMISSION = "TEAM.ROLES.EDIT";
export const PERMISSION_CREATE_PERMISSION = "TEAM.ROLES.PERMISSION";

export const FEEDBACK_CREATE_PERMISSION = "GENERAL.FEEDBACK.CREATE";
export const FEEDBACK_MANAGE_PERMISSION = "GENERAL.FEEDBACK.MANAGE";
export const FEEDBACK_VIEW_PERMISSION = "GENERAL.FEEDBACK.VIEW";

export const PASSWORD_CHANGE_PERMISSION = "TEAM.USERS.CHA5NGE.PASSWORD";